<ng-container *ngIf="this.rendering.fields?.Cards?.length > 1 else noSliderHero">
  <div #HeroLandingSwiper class="swiper pb-swiper-slider">
    <div class="swiper-wrapper" [ngClass]="{'pb-pb-6':energySaveMode}">
      <ng-container *ngFor="let slide of this.rendering.fields?.Cards">
        <div [ngClass]="slide?.fields?.PaginationColor?.value==='White' ? 'pb-pagination-inverse-color' : '' " class="swiper-slide !pb-h-auto">
           <app-hero-internal [rendering]="slide"></app-hero-internal>
        </div>
      </ng-container>
    </div>
    <div class="swiper-pagination pb-swiper-pagination-left md:pb-bottom-[61px] !pb-text-center md:!pb-text-start"></div>
  </div>
</ng-container>

<ng-template #noSliderHero>
  <app-hero-internal [rendering]="this.rendering.fields?.Cards[0]"></app-hero-internal>
</ng-template>